<template>
  <div class="d-flex h-100 align-center justify-center">
    <template v-if="loading">
      <AppLoader />
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import AppLoader from '@/common/AppLoader.vue'
import { getRoomRouteType } from '@/common/utils/rooms'
import { toast } from '@/common/utils/toast'
import { ROOM_DOCUMENTS_ROUTE_NAME } from '@/router/routerData'
import { FilesActionTypes } from '@/store/modules/files/action_types'
import { FilesMutationTypes } from '@/store/modules/files/mutation_types'

export default {
  name: 'WatermarkView',
  components: { AppLoader },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    fileId: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      loading: true,
      file: null,
    }
  },
  computed: {
    ...mapState('files', ['watermarkedDialogData']),
    ...mapState('room', ['currentRoom']),
  },
  async created () {
    try {
      this.file = await this.GET_FILE({
        mnemo: this.mnemo,
        id: this.fileId,
      })
      this.SET_WATERMARKED_DIALOG_DATA({ file: this.file, isOpen: true })
    } catch (e) {
      console.error(e)
      toast.error(this.$t('common.msgFailErrorOccurred'))
    } finally {
      this.closeWatermarkView()
      this.loading = false
    }
  },
  methods: {
    ...mapActions('files', [FilesActionTypes.GET_FILE]),
    ...mapMutations('files', [FilesMutationTypes.SET_WATERMARKED_DIALOG_DATA]),
    closeWatermarkView () {
      this.$router.replace({ name: ROOM_DOCUMENTS_ROUTE_NAME, params: { mnemo: this.mnemo, roomType: getRoomRouteType(this.currentRoom) } })
    },
  },
}
</script>
